'use strict';

import { StaffCollection } from '../../Collections/Staff/StaffCollection';
import { Staff } from '../../Entities/Staff/Staff';
import { CoreRepository } from '../CoreRepository';
import { IpList } from '../../Entities/IpList';
import { IpListCollection } from '../../Collections/IpListCollection';

export class StaffRepository extends CoreRepository {
  public getUserStaff(userId: number, options: object = {}) {
    return this.webAPI.getUserStaff(userId, options).then((response) => {
      const collection = new StaffCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new Staff();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getAgencyStaff(userId: number, agencyId: number, options: object = {}) {
    return this.webAPI.getAgencyStaff(userId, agencyId, options).then((response) => {
      const collection = new StaffCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new Staff();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public updateUserStaff(userId: number, staffId: number, payload: any[]) {
    return this.webAPI.updateUserStaff(userId, staffId, payload).then((response) => {
      return response;
    });
  }

  public getStaffIps(staffId: number, options: object = {}) {
    return this.webAPI.getStaffIps(staffId, options).then((response) => {
      const collection = new IpListCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IpList();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addStaffIp(staffId, payload: object = {}) {
    return this.webAPI.addStaffIp(staffId, payload).then((response) => {
      const ip = new IpList();
      ip.hydrate(response);

      return ip;
    });
  }

  public removeStaffIp(staffId: number, ipId: number, payload: object = {}) {
    return this.webAPI.removeStaffIp(staffId, ipId, payload).then((response) => {
      return response;
    });
  }
}
